import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 意見メッセージ API 操作クラス
 */
export default class OpinionMessages {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET OpinionMessages
   */
  public async get(userStore: LoginUser, caseId: number): Promise<Array<OpinionMessagesGetModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      caseId: caseId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OpinionMessages, formatParams);
    const response = await this.commonService.executeGet<Array<OpinionMessagesGetModel>>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * POST OpinionMessages
   */
  public async post(userStore: LoginUser, caseId: number, requestBody: OpinionMessagesPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      caseId: caseId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OpinionMessages, formatParams);
    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}
/**
 * 意見メッセージ
 */
export interface OpinionMessagesGetModel {
  /** 施設ID */
  facilityId: number;
  /** ケースID */
  caseId: number;
  /** ソートキー{caseId}_{sendTime} */
  opinionMessagesSortKey?: string;
  /** 関係性 */
  familyRelation: string;
  /** 役割 */
  familyPosition: string;
  /** メッセージ内容 */
  content: string;
  /** 送信者 */
  sender: string;
  /** 送信種別() */
  senderType: SendType;
  /** 送信日時 */
  sendTime: number;
  /** 受信者 */
  receiver: string;
  /** 添付ファイル */
  attachedFiles: Array<AttachedFile> | null;
}

/** 意見の種類 */
export enum SendType {
  /** 家族 */
  FAMILY = 0,
  /** 施設 */
  FACILITY = 1
}

export interface OpinionMessagesPostModel {
  /** 利用者ID */
  residentId: number;
  /** 家族ID */
  familyId: number;
  /** 続柄 */
  familyRelation: string;
  /** 役割 */
  familyPosition: string;
  /** コンテンツ */
  content: string;
  /** 送信者ユーザーLINE ID */
  sender: string;
  /** 受信者ユーザーLINE ID */
  receiver: string;
  /** 送信種別 */
  senderType: SendType;
  /** 添付ファイルのS3URL */
  fileUrls: Array<string>;
  /** 添付ファイル名 */
  fileNames: Array<string>;
}

export interface AttachedFile {
  /** ファイル名 */
  name: string;
  /** ファイル種類 */
  type: string;
  /** ファイルURL */
  url: string;
}
